(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Foil Style — PDP behavior
   Loaded by sections/main-product.liquid (referenced from theme.liquid or via
   {{ 'foil-product.js' | asset_url | script_tag }} at the end of the section).
   Reads all Liquid-provided values from data-* attributes + the JSON island,
   so it has zero Liquid dependencies.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.__foilInit) return;
    root.__foilInit = true;

    var presale = root.getAttribute('data-presale') === 'true';
    var klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
    var klaviyoList = root.getAttribute('data-klaviyo-list') || '';
    var productTitle = root.getAttribute('data-product-title') || '';

    var variants = [];
    try {
      var island = root.querySelector('#foilVariantData');
      if (island) variants = JSON.parse(island.textContent || '[]');
    } catch (e) { variants = []; }

    var selected = {}; // optionIndex -> value

    /* ---------- gallery ---------- */
    var thumbs = root.querySelector('#foilThumbs');
    var mainImg = root.querySelector('#foilMainImg');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.foil-thumb');
        if (!btn) return;
        thumbs.querySelectorAll('.foil-thumb').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        mainImg.src = btn.getAttribute('data-src');
      });
    }

    /* ---------- swatches (color) ---------- */
    var swatches = root.querySelector('#foilSwatches');
    var colorVal = root.querySelector('#foilColorVal');
    if (swatches) {
      var ci = parseInt(swatches.getAttribute('data-option-index'), 10);
      var activeSw = swatches.querySelector('.foil-swatch.active');
      if (activeSw) selected[ci] = activeSw.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.foil-swatch');
        if (!s) return;
        swatches.querySelectorAll('.foil-swatch').forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[ci] = s.getAttribute('data-name');
        recompute();
      });
    }

    /* ---------- sizes ---------- */
    var sizes = root.querySelector('#foilSizes');
    if (sizes) {
      var si = parseInt(sizes.getAttribute('data-option-index'), 10);
      var activeSz = sizes.querySelector('.foil-size.active');
      if (activeSz) selected[si] = activeSz.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-size');
        if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.foil-size').forEach(function (x) { x.classList.remove('active'); });
        el.classList.add('active');
        selected[si] = el.getAttribute('data-value');
        recompute();
      });
    }

    /* ---------- variant matching (live mode) ---------- */
    var variantInput = root.querySelector('#foilVariantId');
    var priceEl = root.querySelector('#foilPrice');
    var priceAmt = root.querySelector('#foilPriceAmt');
    var addBtn = root.querySelector('#foilAddBtn');

    function findVariant() {
      var keys = Object.keys(selected);
      return variants.find(function (v) {
        return keys.every(function (k) {
          var idx = parseInt(k, 10); // option position 1..3
          return v['option' + idx] === selected[k];
        });
      });
    }
    function money(cents) {
      try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
    }
    function recompute() {
      var v = findVariant();
      if (variantInput && v) variantInput.value = v.id;
      if (priceAmt && v) priceAmt.textContent = money(v.price);
      if (addBtn) {
        if (v && v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
        else if (v) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      }
    }

    /* ---------- qty ---------- */
    var qtyInput = root.querySelector('#foilQty');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
      });
    });

    /* ---------- accordion ---------- */
    var accordion = root.querySelector('#foilAccordion');
    if (accordion) {
      // if nothing is open by default (e.g. first panel hidden), open the first visible one
      if (!accordion.querySelector('.foil-acc-item.open')) {
        var firstItem = accordion.querySelector('.foil-acc-item');
        if (firstItem) firstItem.classList.add('open');
      }
      accordion.querySelectorAll('.foil-acc-item.open .foil-acc-body').forEach(function (b) {
        b.style.maxHeight = b.scrollHeight + 'px';
      });
      accordion.addEventListener('click', function (e) {
        var h = e.target.closest('.foil-acc-head');
        if (!h) return;
        var item = h.parentElement;
        var body = item.querySelector('.foil-acc-body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    /* ---------- notify modal + Klaviyo ---------- */
    var modal = root.querySelector('#foilModal');
    var notifyBtn = root.querySelector('#foilNotifyBtn');
    var modalX = root.querySelector('#foilModalX');
    var form = root.querySelector('#foilNotifyForm');
    var statusEl = root.querySelector('#foilNotifyStatus');
    var emailEl = root.querySelector('#foilNotifyEmail');

    function openModal() { if (modal) { modal.classList.add('show'); modal.setAttribute('aria-hidden', 'false'); setTimeout(function () { emailEl && emailEl.focus(); }, 60); } }
    function closeModal() { if (modal) { modal.classList.remove('show'); modal.setAttribute('aria-hidden', 'true'); } }

    if (notifyBtn) notifyBtn.addEventListener('click', openModal);
    if (modalX) modalX.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if (!email) return;
        setStatus('Submitting…', '');

        if (!klaviyoKey || !klaviyoList) {
          // No Klaviyo configured yet — succeed gracefully so the UX still works in staging.
          setStatus("You're on the list. (Connect Klaviyo to capture live.)", 'ok');
          form.reset();
          return;
        }

        subscribeKlaviyo(email)
          .then(function () { setStatus("You're on the list. We'll be in touch — no spam.", 'ok'); form.reset(); })
          .catch(function () { setStatus('Something went wrong. Please try again.', 'err'); });
      });
    }

    function setStatus(msg, cls) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : '');
    }

    // Klaviyo Client API — public, browser-safe (subscribe to list).
    // Docs: POST https://a.klaviyo.com/client/subscriptions/?company_id=PUBLIC_KEY
    function subscribeKlaviyo(email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'Interested Product': productTitle, 'Source': 'PDP Notify Me' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
        return true;
      });
    }
  }

  function boot() {
    document.querySelectorAll('.foil-pdp-wrap').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function openOwn(modal){ if(!modal) return; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); var f=modal.querySelector('input'); setTimeout(function(){ f && f.focus(); },60); }
  function closeOwn(modal){ if(!modal) return; modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); }
  function boot(){
    var own = document.getElementById('foilFtrModal');
    document.querySelectorAll('[data-foil-ftr-join]').forEach(function(b){
      if(b.__wired) return; b.__wired = true;
      b.addEventListener('click', function(e){
        // 1) Global header modal (standard pages)
        var trigger = document.querySelector('.foil-hdr-wrap [data-foil-join]');
        if(trigger){ trigger.click(); return; }
        // 2) Homepage's self-contained Formspree modal
        if(typeof window.openFoilstyleModal === 'function'){ window.openFoilstyleModal(e); return; }
        var hp = document.getElementById('foilstyle-modal');
        if(hp){ hp.classList.add('open'); hp.setAttribute('aria-hidden','false'); return; }
        // 3) Footer's own modal (only when no other modal exists)
        openOwn(own);
      });
    });
    // wire the footer's own modal once
    if(own && !own.__wired){
      own.__wired = true;
      own.querySelectorAll('[data-foil-ftr-close]').forEach(function(x){ x.addEventListener('click', function(){ closeOwn(own); }); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeOwn(own); });
      var form = own.querySelector('#foilFtrForm');
      var statusEl = own.querySelector('#foilFtrStatus');
      function setStatus(msg, cls){ if(!statusEl) return; statusEl.textContent = msg; statusEl.className = 'foil-ftr-modal-status' + (cls ? ' ' + cls : ''); }
      if(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          setStatus('Submitting…','');
          var endpoint = form.getAttribute('action');
          if(!endpoint){ setStatus("You're on the list. We'll be in touch.", 'ok'); form.reset(); return; }
          fetch(endpoint, { method:'POST', body:new FormData(form), headers:{ 'Accept':'application/json' } })
            .then(function(r){ if(!r.ok) throw new Error('Form ' + r.status); setStatus("You're on the list. No spam — we'll be in touch.", 'ok'); form.reset(); })
            .catch(function(){ setStatus('Something went wrong. Please try again.', 'err'); });
        });
      }
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__foilHdr) return; root.__foilHdr = true;

    var hdr = root.querySelector('#foilHdr');
    var burger = root.querySelector('#foilBurger');
    var overlay = root.querySelector('#foilOverlay');
    var overlayX = root.querySelector('#foilOverlayX');
    var modal = root.querySelector('#foilJoinModal');
    var modalX = root.querySelector('#foilJoinX');
    var form = root.querySelector('#foilJoinForm');
    var emailEl = root.querySelector('#foilJoinEmail');
    var statusEl = root.querySelector('#foilJoinStatus');
    var search = root.querySelector('#foilSearch');
    var searchBtn = root.querySelector('#foilSearchBtn');
    var searchX = root.querySelector('#foilSearchX');
    var searchInput = root.querySelector('#foilSearchInput');
var overlaySearchBtn = root.querySelector('#foilOverlaySearchBtn');
    // scrolled shadow
    if(hdr){
      var onScroll = function(){ hdr.classList.toggle('scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    }

    // search drawer
    function openSearch(){ if(search){ search.classList.add('open'); search.setAttribute('aria-hidden','false'); searchBtn && searchBtn.setAttribute('aria-expanded','true'); setTimeout(function(){ searchInput && searchInput.focus(); },60); } }
    function closeSearch(){ if(search){ search.classList.remove('open'); search.setAttribute('aria-hidden','true'); searchBtn && searchBtn.setAttribute('aria-expanded','false'); } }
function toggleSearch(){ 
  if(search && search.classList.contains('open')) closeSearch(); 
  else openSearch(); 
}
    searchBtn && searchBtn.addEventListener('click', toggleSearch);
    searchX && searchX.addEventListener('click', closeSearch);
var searchResults = root.querySelector('#foilSearchResults');
var searchTimer;

function escapeHtml(str){
  return String(str).replace(/[&<>"']/g, function(m){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m];
  });
}

function clearSearchResults(){
  if(!searchResults) return;
  searchResults.innerHTML = '';
  searchResults.hidden = true;
}

function renderSearchResults(query, products){
  if(!searchResults) return;

  if(!query || query.length < 2){
    clearSearchResults();
    return;
  }

  if(!products || !products.length){
    searchResults.hidden = false;
    searchResults.innerHTML =
      '<div class="foil-search-empty">Sorry, we couldn’t find anything for <strong>"' +
      escapeHtml(query) +
      '"</strong>.</div>' +
      '<a class="foil-search-viewall" href="/collections/all">Browse all collections →</a>';
    return;
  }

  var html = '<div class="foil-search-status">Search results for "' + escapeHtml(query) + '"</div>';
  html += '<div class="foil-search-list">';

  products.slice(0,4).forEach(function(product){
    var image = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
    var price = product.price ? product.price : '';

    html += '<a class="foil-search-card" href="' + product.url + '">';
    if(image){
      html += '<img src="' + image + '" alt="' + escapeHtml(product.title) + '">';
    }
    html += '<span>';
    html += '<span class="foil-search-title">' + escapeHtml(product.title) + '</span>';
    if(price){
      html += '<span class="foil-search-price">' + price + '</span>';
    }
    html += '</span>';
    html += '</a>';
  });

  html += '</div>';
  html += '<a class="foil-search-viewall" href="/search?q=' + encodeURIComponent(query) + '&type=product">View all results →</a>';

  searchResults.hidden = false;
  searchResults.innerHTML = html;
}

function runPredictiveSearch(){
  if(!searchInput || !searchResults) return;

  var query = searchInput.value.trim();

  if(query.length < 2){
    clearSearchResults();
    return;
  }

  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
    .then(function(response){ return response.json(); })
    .then(function(data){
      var products = data &&
        data.resources &&
        data.resources.results &&
        data.resources.results.products
          ? data.resources.results.products
          : [];

      renderSearchResults(query, products);
    })
    .catch(function(){
      clearSearchResults();
    });
}

searchInput && searchInput.addEventListener('input', function(){
  clearTimeout(searchTimer);
  searchTimer = setTimeout(runPredictiveSearch, 180);
});
    // mobile overlay
function openOverlay(){ 
  if(overlay){ 
    overlay.classList.add('open'); 
    overlay.setAttribute('aria-hidden','false'); 
    document.body.classList.add('foil-menu-open');
    burger && burger.setAttribute('aria-expanded','true'); 
  } 
}

function closeOverlay(){ 
  if(overlay){ 
    overlay.classList.remove('open'); 
    overlay.setAttribute('aria-hidden','true'); 
    document.body.classList.remove('foil-menu-open');
    burger && burger.setAttribute('aria-expanded','false'); 
  } 
}

burger && burger.addEventListener('click', openOverlay);
overlayX && overlayX.addEventListener('click', closeOverlay);

overlaySearchBtn && overlaySearchBtn.addEventListener('click', function(){
  closeOverlay();
  openSearch();
});
    // join modal
    function openModal(){ closeOverlay(); closeSearch(); if(modal){ modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); setTimeout(function(){ var n=root.querySelector('#foilJoinName'); n && n.focus(); },60); } }
    function closeModal(){ if(modal){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); } }
    root.querySelectorAll('[data-foil-join]').forEach(function(b){ b.addEventListener('click', openModal); });
    modalX && modalX.addEventListener('click', closeModal);
    modal && modal.addEventListener('click', function(e){ if(e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeModal(); closeOverlay(); closeSearch(); } });

    function setStatus(msg, cls){ if(!statusEl) return; statusEl.textContent = msg; statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : ''); }

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if(!email) return;
        setStatus('Submitting…','');
        var endpoint = form.getAttribute('action');
        if(!endpoint){ setStatus("You're on the list. We'll be in touch.", 'ok'); form.reset(); return; }
        fetch(endpoint, {
          method:'POST', body:new FormData(form), headers:{ 'Accept':'application/json' }
        }).then(function(r){
          if(!r.ok) throw new Error('Form ' + r.status);
          setStatus("You're on the list. No spam — we'll be in touch.", 'ok'); form.reset();
        }).catch(function(){ setStatus('Something went wrong. Please try again.', 'err'); });
      });
    }
  }
  function boot(){ document.querySelectorAll('.foil-hdr-wrap').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-imatter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__imInit) return;
    root.__imInit = true;

    var variants = [];
    try { variants = JSON.parse((root.querySelector('#imVariantData') || {}).textContent || '[]'); } catch (e) {}
    var selected = {}, colorIdx = null, sizeIdx = null;

    var thumbs = root.querySelector('#imThumbs');
    var mainImg = root.querySelector('#imMainImg');
    var mainWrap = root.querySelector('.im-main-image');
    var mobileTrack = root.querySelector('#imMobileTrack');
    var dots = root.querySelector('#imGalleryDots');
    var prevArrow = root.querySelector('#imGalleryPrev');
    var nextArrow = root.querySelector('#imGalleryNext');
    var galleryItems = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('.im-thumb')) : [];
    var galleryIndex = 0;

    function setActiveDot(index) {
      galleryIndex = index;
      if (!dots) return;
      dots.querySelectorAll('.im-gallery-dot').forEach(function (d) {
        d.classList.remove('active');
      });
      var activeDot = dots.querySelector('[data-index="' + galleryIndex + '"]');
      if (activeDot) activeDot.classList.add('active');
    }

    function setGalleryImage(index) {
      if (!galleryItems.length) return;

      if (index < 0) index = galleryItems.length - 1;
      if (index >= galleryItems.length) index = 0;

      galleryIndex = index;
      var active = galleryItems[galleryIndex];
      if (!active) return;

      galleryItems.forEach(function (t) { t.classList.remove('active'); });
      active.classList.add('active');

      if (mainImg) mainImg.src = active.getAttribute('data-src');
      setActiveDot(galleryIndex);
    }

    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.im-thumb');
        if (!btn) return;
        setGalleryImage(parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        setGalleryImage(galleryIndex - 1);
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        setGalleryImage(galleryIndex + 1);
      });
    }

    if (dots) {
      dots.addEventListener('click', function (e) {
        var dot = e.target.closest('.im-gallery-dot');
        if (!dot) return;

        var index = parseInt(dot.getAttribute('data-index'), 10) || 0;

        if (mobileTrack) {
          mobileTrack.scrollTo({
            left: mobileTrack.clientWidth * index,
            behavior: 'smooth'
          });
        }

        setGalleryImage(index);
        setActiveDot(index);
      });
    }

    if (mobileTrack && dots) {
      var mobileScrollTimer;

      mobileTrack.addEventListener('scroll', function () {
        clearTimeout(mobileScrollTimer);

        mobileScrollTimer = setTimeout(function () {
          var slideWidth = mobileTrack.clientWidth;
          if (!slideWidth) return;

          var index = Math.round(mobileTrack.scrollLeft / slideWidth);
          setActiveDot(index);
        }, 80);
      }, { passive: true });
    }

    if (mainWrap && galleryItems.length > 1) {
      var touchStartX = 0;
      var touchEndX = 0;

      mainWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainWrap.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;

        if (Math.abs(diff) < 45) return;
        if (diff < 0) setGalleryImage(galleryIndex + 1);
        else setGalleryImage(galleryIndex - 1);
      }, { passive: true });
    }

    var swatches = root.querySelector('#imSwatches');
    var colorVal = root.querySelector('#imColorVal');
    if (swatches) {
      colorIdx = parseInt(swatches.getAttribute('data-option-index'), 10);
      var a = swatches.querySelector('.im-swatch.active'); if (a) selected[colorIdx] = a.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.im-swatch'); if (!s) return;
        swatches.querySelectorAll('.im-swatch').forEach(function (x){x.classList.remove('active');});
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[colorIdx] = s.getAttribute('data-name');
        updateSizeAvailability(); recompute();
      });
    }

    var sizes = root.querySelector('#imSizes');
    if (sizes) {
      sizeIdx = parseInt(sizes.getAttribute('data-option-index'), 10);
      var az = sizes.querySelector('.im-size.active'); if (az) selected[sizeIdx] = az.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.im-size'); if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.im-size').forEach(function (x){x.classList.remove('active');});
        el.classList.add('active'); selected[sizeIdx] = el.getAttribute('data-value'); recompute();
      });
    }

    var variantInput = root.querySelector('#imVariantId');
    var priceAmt = root.querySelector('#imPriceAmt');
    var priceWas = root.querySelector('#imPriceWas');
    var addBtn = root.querySelector('#imAddBtn');
    var addLbl = addBtn ? addBtn.querySelector('.lbl') : null;
    function setLabel(t){ if (addLbl) addLbl.textContent = t; else if (addBtn) addBtn.textContent = t; }

    function findVariant(){
      var keys = Object.keys(selected);
      return variants.find(function (v){ return keys.every(function (k){ return v['option'+parseInt(k,10)] === selected[k]; }); });
    }
    function money(c){ try { return '$' + (c/100).toFixed(2); } catch (e){ return ''; } }
    function updateSizeAvailability(){
      if (!sizes || colorIdx == null || sizeIdx == null) return;
      sizes.querySelectorAll('.im-size').forEach(function (el){
        var sv = el.getAttribute('data-value');
        var m = variants.find(function (v){ return v['option'+colorIdx] === selected[colorIdx] && v['option'+sizeIdx] === sv; });
        var ok = m && m.available;
        el.classList.toggle('soldout', !ok);
        if (!ok && el.classList.contains('active')) { el.classList.remove('active'); delete selected[sizeIdx]; }
      });
    }
    function recompute(){
      var v = findVariant();
      if (variantInput && v) variantInput.value = v.id;
      if (priceAmt && v) priceAmt.textContent = money(v.price);
      if (v && priceWas){
        if (v.compare_at_price && v.compare_at_price > v.price){ priceWas.style.display=''; priceWas.textContent=money(v.compare_at_price); }
        else priceWas.style.display='none';
      }
      if (v && v.featured_image && v.featured_image.src && mainImg) mainImg.src = v.featured_image.src;
      if (addBtn){
        if (v && v.available){ addBtn.disabled=false; setLabel('Add to Cart'); }
        else if (v){ addBtn.disabled=true; setLabel('Sold Out'); }
        else { addBtn.disabled=true; setLabel('Select Options'); }
      }
    }

    var qtyInput = root.querySelector('#imQty');
    root.querySelectorAll('[data-qty]').forEach(function (b){
      b.addEventListener('click', function (){ if (!qtyInput) return; var d=parseInt(b.getAttribute('data-qty'),10); qtyInput.value=Math.max(1,(parseInt(qtyInput.value,10)||1)+d); });
    });

    var accordion = root.querySelector('#imAccordion');
    if (accordion) {
      accordion.querySelectorAll('.im-acc-body').forEach(function (body) {
        body.style.maxHeight = '0';
      });

      accordion.addEventListener('click', function (e){
        var h = e.target.closest('.im-acc-head'); if (!h) return;
        var item = h.parentElement, body = item.querySelector('.im-acc-body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    updateSizeAvailability();
    recompute();
  }
  function boot(){ document.querySelectorAll('.foil-imatter').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-product"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Foil Style — PDP behavior
   Loaded by sections/foil-product.liquid (referenced from theme.liquid or via
   {{ 'foil-product.js' | asset_url | script_tag }} at the end of the section).
   Reads all Liquid-provided values from data-* attributes + the JSON island,
   so it has zero Liquid dependencies.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.__foilInit) return;
    root.__foilInit = true;

var presale = root.getAttribute('data-presale') === 'true';
var klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
var klaviyoList = root.getAttribute('data-klaviyo-list') || '';
var productTitle = root.getAttribute('data-product-title') || '';

    var variants = [];
    try {
      var island = root.querySelector('#foilVariantData');
      if (island) variants = JSON.parse(island.textContent || '[]');
    } catch (e) { variants = []; }

    var selected = {}; // optionIndex -> value

   /* ---------- gallery ---------- */
var thumbs = root.querySelector('#foilThumbs');
var mainImg = root.querySelector('#foilMainImg');
var mainWrap = root.querySelector('.foil-main-image');
var dots = root.querySelector('#foilGalleryDots');
var prevArrow = root.querySelector('#foilGalleryPrev');
var nextArrow = root.querySelector('#foilGalleryNext');
var galleryItems = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('.foil-thumb')) : [];
var galleryIndex = 0;

function setGalleryImage(index) {
  if (!mainImg || !galleryItems.length) return;

  if (index < 0) index = galleryItems.length - 1;
  if (index >= galleryItems.length) index = 0;

  galleryIndex = index;
  var active = galleryItems[galleryIndex];
  if (!active) return;

  galleryItems.forEach(function (t) { t.classList.remove('active'); });
  active.classList.add('active');
  mainImg.src = active.getAttribute('data-src');

  if (dots) {
    dots.querySelectorAll('.foil-gallery-dot').forEach(function (d) { d.classList.remove('active'); });
    var activeDot = dots.querySelector('[data-index="' + galleryIndex + '"]');
    if (activeDot) activeDot.classList.add('active');
  }
}

function showVariantImage(variant) {
  if (!variant || !variant.featured_image_id) return;

  var imageId = String(variant.featured_image_id);
  var matchingThumb = galleryItems.find(function (thumb) {
    return thumb.getAttribute('data-image-id') === imageId;
  });

  if (!matchingThumb) return;

  var index = parseInt(matchingThumb.getAttribute('data-index'), 10);
  if (isNaN(index)) return;

  setGalleryImage(index);

  if (mobileTrack) {
    mobileTrack.scrollTo({
      left: mobileTrack.clientWidth * index,
      behavior: 'smooth'
    });
  }

  setActiveDot(index);
}

if (thumbs && mainImg) {
  thumbs.addEventListener('click', function (e) {
    var btn = e.target.closest('.foil-thumb');
    if (!btn) return;
    setGalleryImage(parseInt(btn.getAttribute('data-index'), 10) || 0);
  });
}

if (prevArrow) {
  prevArrow.addEventListener('click', function () {
    setGalleryImage(galleryIndex - 1);
  });
}

if (nextArrow) {
  nextArrow.addEventListener('click', function () {
    setGalleryImage(galleryIndex + 1);
  });
}

if (dots) {
  dots.addEventListener('click', function (e) {
    var dot = e.target.closest('.foil-gallery-dot');
    if (!dot) return;

    var index = parseInt(dot.getAttribute('data-index'), 10) || 0;

    if (mobileTrack) {
      mobileTrack.scrollTo({
        left: mobileTrack.clientWidth * index,
        behavior: 'smooth'
      });
    }

    setGalleryImage(index);
    setActiveDot(index);
  });
}
var mobileTrack = root.querySelector('#foilMobileTrack');

function setActiveDot(index) {
  galleryIndex = index;

  if (dots) {
    dots.querySelectorAll('.foil-gallery-dot').forEach(function (d) {
      d.classList.remove('active');
    });

    var activeDot = dots.querySelector('[data-index="' + galleryIndex + '"]');
    if (activeDot) activeDot.classList.add('active');
  }
}

if (mobileTrack && dots) {
  var mobileScrollTimer;

  mobileTrack.addEventListener('scroll', function () {
    clearTimeout(mobileScrollTimer);

    mobileScrollTimer = setTimeout(function () {
      var slideWidth = mobileTrack.clientWidth;
      if (!slideWidth) return;

      var index = Math.round(mobileTrack.scrollLeft / slideWidth);
      setActiveDot(index);
    }, 80);
  }, { passive: true });

  dots.addEventListener('click', function (e) {
    var dot = e.target.closest('.foil-gallery-dot');
    if (!dot) return;

    var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
    mobileTrack.scrollTo({
      left: mobileTrack.clientWidth * index,
      behavior: 'smooth'
    });

    setActiveDot(index);
  });
}

if (mainWrap && galleryItems.length > 1) {
  var touchStartX = 0;
  var touchEndX = 0;

  mainWrap.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  mainWrap.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchEndX - touchStartX;

    if (Math.abs(diff) < 45) return;
    if (diff < 0) setGalleryImage(galleryIndex + 1);
    else setGalleryImage(galleryIndex - 1);
  }, { passive: true });
}

    /* ---------- swatches (color) ---------- */
    var swatches = root.querySelector('#foilSwatches');
    var colorVal = root.querySelector('#foilColorVal');
    if (swatches) {
      var ci = parseInt(swatches.getAttribute('data-option-index'), 10);
      var activeSw = swatches.querySelector('.foil-swatch.active');
      if (activeSw) selected[ci] = activeSw.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.foil-swatch');
        if (!s) return;
        swatches.querySelectorAll('.foil-swatch').forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[ci] = s.getAttribute('data-name');
        recompute();
      });
    }


    /* ---------- cuts ---------- */
    var cuts = root.querySelector('#foilCuts');
    if (cuts) {
      var cutIndex = parseInt(cuts.getAttribute('data-option-index'), 10);
      var activeCut = cuts.querySelector('.foil-cut.active');
      if (activeCut) selected[cutIndex] = activeCut.getAttribute('data-value');
      cuts.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-cut');
        if (!el || el.classList.contains('soldout')) return;
        cuts.querySelectorAll('.foil-cut').forEach(function (x) { x.classList.remove('active'); });
        el.classList.add('active');
        selected[cutIndex] = el.getAttribute('data-value');
        recompute();
      });
    }

    /* ---------- sizes ---------- */
    var sizes = root.querySelector('#foilSizes');
    if (sizes) {
      var si = parseInt(sizes.getAttribute('data-option-index'), 10);
      var activeSz = sizes.querySelector('.foil-size.active');
      if (activeSz) selected[si] = activeSz.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-size');
        if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.foil-size').forEach(function (x) { x.classList.remove('active'); });
        el.classList.add('active');
        selected[si] = el.getAttribute('data-value');
        recompute();
      });
    }

    /* ---------- variant matching (live mode) ---------- */
var variantInput = root.querySelector('#foilVariantId');
var priceAmt = root.querySelector('#foilPriceAmt');
var addBtn = root.querySelector('#foilAddBtn');

function findVariant() {
  var keys = Object.keys(selected);
  if (!variants.length || !keys.length) return null;

  return variants.find(function (v) {
    return keys.every(function (k) {
      var idx = parseInt(k, 10);
      return v['option' + idx] === selected[k];
    });
  }) || null;
}

function money(cents) {
  var amount = Number(cents);
  if (isNaN(amount)) return '';
  var value = amount / 100;
  return '$' + (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2));
}

function recompute() {
  var v = findVariant();

  if (variantInput && v) variantInput.value = v.id;
  if (priceAmt && v) priceAmt.textContent = money(v.price);
  if (v) showVariantImage(v);

  if (!addBtn) return;

  if (v && v.available) {
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Cart';
  } else if (v) {
    addBtn.disabled = true;
    addBtn.textContent = 'Sold Out';
  } else {
    addBtn.disabled = true;
    addBtn.textContent = 'Unavailable';
  }
}

    /* ---------- qty ---------- */
    var qtyInput = root.querySelector('#foilQty');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
      });
    });

    /* ---------- accordion ---------- */
var accordion = root.querySelector('#foilAccordion');

if (accordion) {
  accordion.querySelectorAll('.foil-acc-body').forEach(function (body) {
    body.style.maxHeight = '0';
  });

  accordion.addEventListener('click', function (e) {
    var h = e.target.closest('.foil-acc-head');
    if (!h) return;

var item = h.parentElement;
if (!item) return;

var body = item.querySelector('.foil-acc-body');
if (!body) return;

var open = item.classList.toggle('open');
body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
  });
}

    /* ---------- size guide modal ---------- */
    var sizeGuideModal = root.querySelector('[data-size-guide-modal]');
    var sizeGuideButtons = root.querySelectorAll('[data-size-guide-open]');
    var sizeGuideClose = root.querySelector('[data-size-guide-close]');
    var sizeGuideTabs = sizeGuideModal ? Array.prototype.slice.call(sizeGuideModal.querySelectorAll('[data-size-guide-tab]')) : [];
    var sizeGuidePanels = sizeGuideModal ? Array.prototype.slice.call(sizeGuideModal.querySelectorAll('[data-size-guide-panel]')) : [];
    var activeSizeGuideTrigger = null;

    function normalizeGuideValue(value) {
      return String(value || '').trim().toLowerCase();
    }

    function activateSizeGuide(index) {
      if (!sizeGuideTabs.length || !sizeGuidePanels.length) return;

      sizeGuideTabs.forEach(function (tab) {
        var active = tab.getAttribute('data-guide-index') === String(index);
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      sizeGuidePanels.forEach(function (panel) {
        var active = panel.getAttribute('data-guide-index') === String(index);
        panel.classList.toggle('active', active);
        panel.hidden = !active;
      });
    }

    function activateGuideForSelectedCut() {
      if (!sizeGuideTabs.length) return;

      var activeCut = root.querySelector('.foil-cut.active');
      var selectedCut = activeCut ? normalizeGuideValue(activeCut.getAttribute('data-value') || activeCut.textContent) : '';
      if (!selectedCut) {
        activateSizeGuide(sizeGuideTabs[0].getAttribute('data-guide-index') || '0');
        return;
      }

      var match = sizeGuideTabs.find(function (tab) {
        return normalizeGuideValue(tab.getAttribute('data-guide-match')) === selectedCut;
      });

      // Helpful fallback: labels such as "Relaxed Cut" can still match a selected value of "Relaxed".
      if (!match) {
        match = sizeGuideTabs.find(function (tab) {
          var guideMatch = normalizeGuideValue(tab.getAttribute('data-guide-match'));
          return guideMatch.indexOf(selectedCut) !== -1 || selectedCut.indexOf(guideMatch) !== -1;
        });
      }

      activateSizeGuide((match || sizeGuideTabs[0]).getAttribute('data-guide-index') || '0');
    }

    function openSizeGuide(event) {
      if (!sizeGuideModal) return;
      activeSizeGuideTrigger = event && event.currentTarget ? event.currentTarget : null;
      activateGuideForSelectedCut();
      sizeGuideModal.classList.add('show');
      sizeGuideModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        if (sizeGuideClose) sizeGuideClose.focus();
      }, 60);
    }

    function closeSizeGuide() {
      if (!sizeGuideModal) return;
      sizeGuideModal.classList.remove('show');
      sizeGuideModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (activeSizeGuideTrigger) activeSizeGuideTrigger.focus();
      activeSizeGuideTrigger = null;
    }

    sizeGuideButtons.forEach(function (button) {
      button.addEventListener('click', openSizeGuide);
    });

    sizeGuideTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateSizeGuide(tab.getAttribute('data-guide-index') || '0');
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIndex = sizeGuideTabs.indexOf(tab);
        var nextIndex = e.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;
        if (nextIndex < 0) nextIndex = sizeGuideTabs.length - 1;
        if (nextIndex >= sizeGuideTabs.length) nextIndex = 0;
        var nextTab = sizeGuideTabs[nextIndex];
        activateSizeGuide(nextTab.getAttribute('data-guide-index') || '0');
        nextTab.focus();
      });
    });

    if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
    if (sizeGuideModal) {
      sizeGuideModal.addEventListener('click', function (e) {
        if (e.target === sizeGuideModal) closeSizeGuide();
      });
    }

    /* ---------- notify modal + Klaviyo ---------- */
    var modal = root.querySelector('#foilModal');
    var notifyBtn = root.querySelector('#foilNotifyBtn');
    var modalX = root.querySelector('#foilModalX');
    var form = root.querySelector('#foilNotifyForm');
    var statusEl = root.querySelector('#foilNotifyStatus');
    var emailEl = root.querySelector('#foilNotifyEmail');

    function openModal() { if (modal) { modal.classList.add('show'); modal.setAttribute('aria-hidden', 'false'); setTimeout(function () { emailEl && emailEl.focus(); }, 60); } }
    function closeModal() { if (modal) { modal.classList.remove('show'); modal.setAttribute('aria-hidden', 'true'); } }

    if (notifyBtn) notifyBtn.addEventListener('click', openModal);
    if (modalX) modalX.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (sizeGuideModal && sizeGuideModal.classList.contains('show')) {
        closeSizeGuide();
        return;
      }
      closeModal();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if (!email) return;
        setStatus('Submitting…', '');

        if (!klaviyoKey || !klaviyoList) {
          // No Klaviyo configured yet — succeed gracefully so the UX still works in staging.
          setStatus("You're on the list. (Connect Klaviyo to capture live.)", 'ok');
          form.reset();
          return;
        }

        subscribeKlaviyo(email)
          .then(function () { setStatus("You're on the list. We'll be in touch — no spam.", 'ok'); form.reset(); })
          .catch(function () { setStatus('Something went wrong. Please try again.', 'err'); });
      });
    }

    function setStatus(msg, cls) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : '');
    }

    // Klaviyo Client API — public, browser-safe (subscribe to list).
    // Docs: POST https://a.klaviyo.com/client/subscriptions/?company_id=PUBLIC_KEY
    function subscribeKlaviyo(email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'Interested Product': productTitle, 'Source': 'PDP Notify Me' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
        return true;
      });
    }
  }

  function boot() {
    document.querySelectorAll('.foil-pdp-wrap').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
